export class ObservableProperty {
    constructor(value) {
        this._onPropertyChanged = [];
        this._value = value;
    }
    dispose() {
        this._onPropertyChanged.length = 0;
    }
    Subscribe(callback) {
        if (!this._onPropertyChanged.includes(callback))
            this._onPropertyChanged.push(callback);
    }
    Unsubscribe(callback) {
        if (this._onPropertyChanged.includes(callback))
            this._onPropertyChanged.splice(this._onPropertyChanged.indexOf(callback), 1);
    }
    get Value() {
        return this._value;
    }
    set Value(value) {
        if (this._value === value)
            return;
        const oldValue = this._value;
        this._value = value;
        this._onPropertyChanged.forEach(c => c(value, oldValue));
    }
}
